export const CONSENT_LIST_STATUS_FILTERS = ['all', 'published', 'draft', 'archived'];
const familyForFilter = (versions, filter) => {
    const latest = versions[0];
    if (!latest) {
        return null;
    }
    switch (filter) {
        case 'all':
            return {
                parent: latest,
                // Expand only other-status versions — same-status older drafts stay hidden.
                siblings: versions.filter((file) => file.id !== latest.id && file.status !== latest.status),
            };
        case 'draft':
            if (latest.status !== 'Draft') {
                return null;
            }
            return { parent: latest, siblings: versions.filter((file) => file.status === 'Published') };
        case 'published': {
            const published = versions.filter((file) => file.status === 'Published');
            if (!published[0]) {
                return null;
            }
            return { parent: published[0], siblings: versions.filter((file) => file.status === 'Draft') };
        }
        case 'archived': {
            const archived = versions.filter((file) => file.status === 'Archived');
            if (!archived[0]) {
                return null;
            }
            return { parent: archived[0], siblings: archived.slice(1) };
        }
    }
};
export const groupConsentTemplateRows = (files, filter, searchValue = '') => {
    const term = searchValue.trim().toLowerCase();
    const grouped = new Map();
    for (const file of files) {
        const existing = grouped.get(file.templateKey);
        if (existing) {
            existing.push(file);
            continue;
        }
        grouped.set(file.templateKey, [file]);
    }
    const families = [];
    const createdAtMsByTemplateKey = new Map();
    for (const versions of grouped.values()) {
        versions.sort((left, right) => right.version - left.version || left.id.localeCompare(right.id));
        const family = familyForFilter(versions, filter);
        if (!family) {
            continue;
        }
        const visibleVersions = [family.parent, ...family.siblings];
        if (term &&
            !visibleVersions.some((file) => file.title.toLowerCase().includes(term) ||
                file.description.toLowerCase().includes(term) ||
                (file.language ?? '').toLowerCase().includes(term))) {
            continue;
        }
        createdAtMsByTemplateKey.set(family.parent.templateKey, newestCreatedAtMs(versions));
        families.push(family);
    }
    families.sort((left, right) => (createdAtMsByTemplateKey.get(right.parent.templateKey) ?? 0) -
        (createdAtMsByTemplateKey.get(left.parent.templateKey) ?? 0));
    return families;
};
const newestCreatedAtMs = (versions) => {
    let newest = 0;
    for (const file of versions) {
        if (!file.createdAt) {
            continue;
        }
        const timestamp = Date.parse(file.createdAt);
        if (!Number.isNaN(timestamp) && timestamp > newest) {
            newest = timestamp;
        }
    }
    return newest;
};
export const lineageHasDraft = (files, templateKey) => files.some((file) => file.templateKey === templateKey && file.status === 'Draft');
